(function () {
    window.enableDebug = function enableDebug() {
        sessionStorage.setItem('debugMode', 'true');
        console.log('%cDebug mode enabled', 'color: green; font-weight: bold;');
        window.dispatchEvent(new Event('debugModeChanged'));
    };

    window.disableDebug = function disableDebug() {
        sessionStorage.removeItem('debugMode');
        console.log('%cDebug mode disabled', 'color: red; font-weight: bold;');
        window.dispatchEvent(new Event('debugModeChanged'));
    };

    window.isDebugMode = function isDebugMode() {
        return sessionStorage.getItem('debugMode') === 'true';
    };
})();
